import { Alert, Box, Button, Collapse, Grid, IconButton, Paper, TextField, styled } from "@mui/material";
import { useRef, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

export default function DocumentosAdjuntosFormulario(props) {
    const [documentoAdjunto, setDocumentoAdjunto] = useState({ ruta: '', descripcion: '', documentos: new FormData(), indice: 0 })

    const [loading, setLoading] = useState(false)

    const [errorDocumentoPDF, setErrorDocumentoPDF] = useState(false)
    const { documentosGuardados, setDocumentosGuardados, idAutor, idSolicitud } = props
    const [helperTextDocumentoPDF, setHelperTextDocumentoPDF] = useState('')
    const [indice, setIndice] = useState(1)
    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [severity, setSeverity] = useState('error')
    const limpiar = useRef(null)
    const documentoF = useRef(null)
  
    const handleDocumentos = async (event) => {
        const files = event.target.files
        if (!files) {
            return
        }

        documentoAdjunto.documentos.delete('PDF')
        //console.log(`event.target.files ${files.length}`)

        const file = files[0]
        //console.log(`Documento ${file.name}`)
        
        /*documentos.map((documentoGuardado) => {
            if (file.name === documentoGuardado.documentos.get('PDF').name) {
                setHelperTextDocumentoPDF('Ese documento ya está registrado en el listado de arriba, si deseas cambiar la descripción bórralo (icono de bote de basura) y vuelve a registrarlo')
                setErrorDocumentoPDF(true)
                error = true
            }
        })
        if (Boolean(error))
            return
*/
        /*let regex = /([^-\w.]*)/gm;
        const nombreArchivo = file.name.replace(regex, '');
        console.log(`nombreArchivo ${nombreArchivo}`)
        const resVerificar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/verificarDocumento`, {
            method: "GET",
            headers: {
                "nombre": nombreArchivo
            }
        })
        if (resVerificar.status === 200) {
            setErrorDocumentoPDF(true)
            setHelperTextDocumentoPDF('Ya existe un archivo registrado con ese nombre, por favor renómbralo')
            return
        }
        else {
            setErrorDocumentoPDF(false)
            setHelperTextDocumentoPDF('')
        }*/
        if (event.target.value) {
            //console.log(`event.target.value ${event.target.value} ${event.target.value.endsWith(".jpg")}`)
            if (event.target.value.endsWith(".PDF") || event.target.value.endsWith(".pdf") || event.target.value.endsWith(".PNG") || event.target.value.endsWith(".png") || event.target.value.endsWith(".JPG") || event.target.value.endsWith(".jpg") || event.target.value.endsWith(".JPEG") || event.target.value.endsWith(".jpeg")) {

                setHelperTextDocumentoPDF('')
                setErrorDocumentoPDF(false)
            }
            else {
                setHelperTextDocumentoPDF(`Formato de archivo no válido, se requiere PDF PNG, JPG o JPEG`)
                setErrorDocumentoPDF(true)
                return
            }
            if (file.size > 5242880) {
                setHelperTextDocumentoPDF('El tamaño del archivo debe ser menor a 5MB')
                setErrorDocumentoPDF(true)
                return
            }
            else {
                setHelperTextDocumentoPDF('')
                setErrorDocumentoPDF(false)
            }
            //console.log(`event.target.value.match(/[A-Za-z0-9_-]/gi) ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi)} ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi).length} cadena ${event.target.files[0].name.length}`)
            // Si la longitud coincide significa que sólo se encontraron letras, números y guiones
            /*if (file.name.match(/[A-Za-z0-9_-]/gi).length === file.name.length - 1) //Se resta uno por el punto de la extensión
            {
                setHelperTextDocumentoPDF('')
                setErrorDocumentoPDF(false)
            }
            
            else {
                setHelperTextDocumentoPDF('El nombre del archivo no debe contener caracteres especiales como acentos o espacios en blanco, puede separar palabras con - o _')
                setErrorDocumentoPDF(true)
                return
            }*/
            setHelperTextDocumentoPDF('')
            setErrorDocumentoPDF(false)
        }

        documentoAdjunto.documentos.append('PDF', file)

    }

    const almacenarTemporalmente = async (e) => {
        e.preventDefault()
        e.stopPropagation()
        const archivoPDF = new FormData();
        const file = documentoAdjunto.documentos.get('PDF')
        if (!file) {
            setErrorDocumentoPDF(true)
            setHelperTextDocumentoPDF('Debe seleccionar un archivo')
            return
        }
        setErrorDocumentoPDF(false)
        setHelperTextDocumentoPDF('')
        archivoPDF.append('documento', documentoAdjunto.documentos.get('PDF'));
        const resUploadPDF = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadDocumentoSolicitud`, {
            method: "POST",
            body: archivoPDF
        })
        const ruta = (await resUploadPDF.json()).ruta

        documentoAdjunto.ruta = ruta
        documentoAdjunto.idSolicitud = idSolicitud
        documentoAdjunto.idAutor = idAutor
        setIndice(indice + 1)
        documentoAdjunto.indice = indice
        const resDocumento = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/guardarDocumentoSolicitud`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            },
            body: JSON.stringify(documentoAdjunto)
        })
        const data = await resDocumento.json()
        if (resDocumento.status === 200) {
            setSeverity('success')
            documentosGuardados.push(data.documento)
            //console.log(`documentosGuardados ${JSON.stringify(documentosGuardados)}`)
            setDocumentosGuardados([...documentosGuardados])
        }
        else
            setSeverity('error')
        setMensaje(data.message)
        setOpen(true)
        if (documentoF.current)
            documentoF.current.value = null
        //document.getElementById('documento').value = null
        setDocumentoAdjunto({ ruta: '', descripcion: '', documentos: new FormData(), indice })
        if (limpiar.current)
            limpiar.current.click()
    }

    return (
        <Grid item xs={12} sm={12}>
            <Box sx={{ flexGrow: 1, marginLeft: '20px', marginTop: '50px' }}>
                <Grid container spacing={2}>
                    <Grid container xs={12} md={12} lg={12}>
                        <Grid xs={12} md={12} spacing={2}>
                            <Item>
                                <Box
                                    id="category-c"
                                    sx={{ fontSize: '12px', textTransform: 'none', fontWeight: 700, mb: 2 }}
                                >
                                    Documentos Adjuntos<Box component="div" sx={{ textTransform: 'none', fontWeight: 500, fontStyle: 'italic' }}>(Adjuntar sólo si no es obligatorio el documento que desea añadir. Si el documento es obligatorio para el tipo de solicitud es mejor realizar ajustes. )</Box>



                                    <Box component="div" aria-labelledby="category-c" sx={{ p: 2, textAlign: "left" }}>
                                        <form onSubmit={almacenarTemporalmente}>
                                            <Grid container direction='row' justifyContent='center' spacing={2}>
                                                <Grid item sm={12} xs={12}>
                                                    <TextField label='Documento (PDF PNG, JPG o JPEG)' focused name='documento' ref={documentoF} accept="application/pdf" helperText={helperTextDocumentoPDF} error={errorDocumentoPDF} sx={{ width: '100%' }} type="file" onChange={handleDocumentos} />
                                                </Grid>
                                                <Grid item sm={12} xs={12}>
                                                    <TextField label='Descripción' focused name='descripcion' multiline fullWidth
                                                        onChange={(event) => {
                                                            documentoAdjunto.descripcion = event.target.value;
                                                            //console.log(documentoAdjunto)
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <Box sx={{ width: '100%' }}>
                                                        <Collapse in={open}>
                                                            <Alert severity={severity}
                                                                action={
                                                                    <IconButton
                                                                        aria-label="close"
                                                                        color="inherit"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            setOpen(false);
                                                                        }}
                                                                    >
                                                                        <CloseIcon fontSize="inherit" />
                                                                    </IconButton>
                                                                }
                                                                style={{ marginTop: 30 }}
                                                            >
                                                                {mensaje}
                                                            </Alert>
                                                        </Collapse>
                                                    </Box>
                                                    <Button variant='contained' color='primary' type='submit' style={{ marginTop: 20 }} disabled={loading} >
                                                        Subir documento
                                                    </Button>
                                                    <Button variant='contained' color='primary' type='reset' style={{ marginTop: 20, marginLeft: 20 }} ref={limpiar} onClick={() => { setErrorDocumentoPDF(false); setHelperTextDocumentoPDF(''); setDocumentoAdjunto({ ruta: '', descripcion: '', documentos: new FormData(), indice }) }}>Limpiar</Button>
                                                </Grid>
                                            </Grid>
                                        </form>
                                    </Box>
                                </Box>
                            </Item>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    )
}

